import { axiosInstance } from '@/lib/axios';
import { ImportTaskStatusProps } from './types';
import { TaskModel } from '@/app/models/tasks/taskModel';

export const getImportTaskStatus = ({ importTaskId } : ImportTaskStatusProps) => {
  return axiosInstance.get<TaskModel>(`/config-api/importTask/status?&id=${importTaskId}`);
}
